import { render, staticRenderFns } from "./create_components.vue?vue&type=template&id=33f95afa&scoped=true"
import script from "./create_components.vue?vue&type=script&lang=js"
export * from "./create_components.vue?vue&type=script&lang=js"
import style0 from "./create_components.vue?vue&type=style&index=0&id=33f95afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f95afa",
  null
  
)

export default component.exports